import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';
import {
  fetchSectorListModule,
  fetchCOISectorListAPI
} from './helpAndAssistantApi';

export interface SectorListState {
  sectorList: Array<any>;
  coiSectorList: Array<any>;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: SectorListState = {
  sectorList: [],
  coiSectorList: [],
  status: 'idle'
};

export const GetSectorList = createAsyncThunk(
  'SectorList/fetchCompany',
  async () => {
    const response = await fetchSectorListModule();
    return response;
  }
);

export const GetCoiSectorList = createAsyncThunk(
  'SectorList/fetchCoiSector',
  async () => {
    const response = await fetchCOISectorListAPI();
    return response;
  }
);

export const SectorListSlice = createSlice({
  name: 'SectorList',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetSectorList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(GetSectorList.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(GetSectorList.fulfilled, (state, action) => {
        state.status = 'idle';
        state.sectorList = action.payload.sector;
      })

      .addCase(GetCoiSectorList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(GetCoiSectorList.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(GetCoiSectorList.fulfilled, (state, action) => {
        state.status = 'idle';
        state.coiSectorList = action.payload;
      });
  }
});

export const {} = SectorListSlice.actions;

export const selectSectorList = (state: RootState) => {
  return state.SectorList.sectorList;
};

export const selectCoiSectorList = (state: RootState) => {
  return state.SectorList.coiSectorList;
};

export default SectorListSlice.reducer;
